import React from "react";
import { FaFacebookSquare } from "react-icons/fa";
import { BsInstagram } from "react-icons/bs";
import { BsTwitter } from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa";
import { BiLogoGithub } from "react-icons/bi";
import { VscSend } from "react-icons/vsc";
import MyImage from "../images/myimage.jpg";
import "animate.css";
import ScrollDown from "./ScrollDown";
import { Typewriter } from "react-simple-typewriter";

const Header = () => {
  return (
    <>
      <div className="header" id="home">
        <div className="headerCon">
          <div className="headIcons animate__animated animate__fadeInDown">
            <a
              href="https://www.facebook.com/profile.php?id=100011556826825"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookSquare className="headIcon" />
            </a>
            <a
              href="https://www.instagram.com/hammad_khan044/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <BsInstagram className="headIcon" />
            </a>
            <a
              href="https://www.linkedin.com/feed/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin className="headIcon" />
            </a>
            <a
              href="https://github.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <BiLogoGithub className="headIcon" />
            </a>
          </div>

          <h1 className="head animate__animated animate__fadeInLeft">
            Muhammad Hammad
          </h1>

          <p className="subHead animate__animated animate__fadeInRight">
            I'm a
            <Typewriter
              words={[
                " Web Developer",
                " Graphic Designer",
                " Freelancer",
                " MERN Stack Developer",
              ]}
              loop="infinit"
              cursor
              cursorStyle="|"
              typeSpeed={70}
              deleteSpeed={50}
              delaySpeed={1000}
            />
          </p>

          <p className="subPara animate__animated animate__fadeInRight">
            I'm a Creative Web Developer Based in Hyderbad, Pakistan and I'm
            very passionate and dedicated to my work.
          </p>

          <div className="headBtn">
            <a href="#contact">
              <button className="mainBtn animate__animated animate__fadeInUp">
                Say Hello
                <VscSend className="btnSpan" />
              </button>
            </a>
          </div>
        </div>

        <div className="headerImg">
          <img src={MyImage} alt="" />
        </div>
      </div>
      <ScrollDown />
    </>
  );
};

export default Header;
